export default "__VITE_ASSET__BJpHKqBt__"